import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormArray,
} from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { isNumber } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, concat, Observable, of, Subject, throwError } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  takeUntil,
  tap,
  finalize,
} from 'rxjs/operators';
import Swal from 'sweetalert2';

import {
  AtMentionItem,
  AtMentionItemType,
} from '@app/core/_common/at-mention/at-mention.model';
import { lumConfig } from '@app/core/_config/lum.config';
import {
  CostCalculationMethodSetting,
  UserPermissionCodeConstant,
} from '@app/core/_constant/index.constants';
import { ProductTypes } from '@app/core/_constant/product-type.constants';
import { SettingsKey } from '@app/core/_constant/settings.constants';
import { AuthService } from '@app/core/auth';
import { ClientPurchaseOrderService } from '@app/core/client/services/client-purchase-order.service';
import { ClientService } from '@app/core/client/services/client.service';
import { BusinessAccount } from '@app/core/client/store/client.model';
import { Factory, FactoryService } from '@app/core/factories';
import { LocationService } from '@app/core/locations/services/location.service';
import { ProductTagService } from '@app/core/product-tags/services/product-tag.service';
import { PoService } from '@app/core/purchase-orders/services/po.service';
import { RfqService } from '@app/core/quotes';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { StaffService } from '@app/core/staff';
import { UnitConversionRuleService } from '@app/core/unit-measurement/services/unit-conversion-rule/unit-conversion-rule.service';
import { EFeatureFlag } from '@app/feature-toggle-list';
import {
  IPurchaseOrderMultiselectLineItem,
  PurchaseOrderLineItemFormField,
} from '@app/interfaces/purchase-order.model';
import { AuthFormModalComponent } from '@app/modules/factories/form-modal/form-modal.component';
import { CreateClientRfqComponent } from '@app/modules/inventory/create-client-rfq/create-client-rfq.component';
import { RfqVariantSkusPopupComponent } from '@app/modules/inventory/rfq-variant-skus-popup/rfq-variant-skus-popup.component';
import { UnitMeasureInterface } from '@app/modules/unit-measurement/interfaces';
import { AddOrderItemsFormComponent } from '@app/shared/components/purchase-orders/add-order-items-form/add-order-items-form.component';
import { DraggableLineItemHelperService } from '@app/shared/services/draggable-line-item-helper.service';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';
import {
  RfqKitItemsAddFormComponent,
  RfqLineItemsFormComponent,
} from 'v2/modules/rfq/components';
import { DialogConfig } from 'v2/modules/shared/configs/dialog.config';
import { SnackBarConfig } from 'v2/modules/shared/configs/snackbar.config';
import { IWarehouseGroup } from 'v2/modules/shared/interfaces/location-warehouse.interface';
import { DecimalPlacesPipe } from 'v2/modules/shared/pipes/decimal-places.pipe';
import { LocationWarehouseGroupApiService } from 'v2/modules/shared/services/api/location/location-warehouse-group-api.service';
import { ErrorHandlingUtilService } from 'v2/modules/shared/services/util/error-handling-util.service';
import { FeatureFlagPipe } from 'v2/shared/feature/feature-flag.pipe';

import { DecimalPlacesUtils } from './../../../../v2/modules/shared/util/decimal-places.utils';
import { CustomFieldApiService } from '../../../../v2/modules/shared/services/api/custom-field-api.service';
import { ECustomFieldObject, ICustomField } from 'v2/modules/custom-field/interfaces/custom-field.interface';

@Component({
  selector: 'cnc-purchase-order-inline-form',
  templateUrl: './purchase-order-inline-form.component.html',
  styleUrls: ['./purchase-order-inline-form.component.scss'],
  providers: [DatePipe, FeatureFlagPipe],
})
export class PurchaseOrderInlineFormComponent implements OnInit, OnDestroy {
  loading :boolean = false;
  pageTitle :string = 'Loading Page...';
  formData :UntypedFormGroup;
  activeTab :number = 0;

  paymentTerms :any[] = [];
  factoryItems :any[] = [];
  inventoryItems :any[] = [];
  activeFactory :any;
  logistics :any[] = [];

  warehouses :any[] = [];
  default_warehouse_id :number = 0;
  shipToAddressLookUp :any[] = [
    {
      label: 'Manually add Ship to Address',
      value: 'ship_to_address',
    },
    {
      label: 'Warehouse',
      value: 'warehouse',
    },
  ];
  @Input() purchaseOrder :any;
  @Input() rfq :any;
  @Input() quotation :any;
  isModal :boolean = false;
  stockGridItemIds :string;
  hasProcessedSKUs = false;

  manualSet :boolean = false;
  isPageLoad :boolean = false;
  sysSettings :any;
  showIntlShipping :boolean;
  logistic_1_payment_term :string;
  purchaseOrderId :number;

  poItems :any[] = [];
  total :any = {
    quantity: 0,
    amount: 0,
  };
  rfq$ :Observable<any[]>;
  rfqLoading = false;
  rfqInput$ = new Subject<string>();

  custom_item_total :any = {
    quantity: 0,
    amount: 0,
  };

  tags :any = [];
  staff = [] as AtMentionItem[];

  checkedAll :any = {
    po_items: false,
    po_custom_items: false,
  };

  lineItemFormField = PurchaseOrderLineItemFormField;

  client$ :Observable<BusinessAccount[]>;
  clientLoading = false;
  clientInput$ = new Subject<string>();

  invoices$ :Observable<any[]>;
  invoiceLoading$ :Observable<boolean>;
  invoiceInput$ = new Subject<string>();

  factory$ :Observable<Factory[]>;

  selectedClients :any[];
  selectedInvoices :any[];

  private readonly _kitRfqs = new BehaviorSubject<any>(<any>[]);
  public kitRfqs$ = this._kitRfqs.asObservable();

  private onDestroy$ = new Subject();

  unitOfMeasures :UnitMeasureInterface[] = [];
  private uomRules :any[] = [];

  inputColumns :number = 7;
  isOpen :boolean[] = [];

  loadingUomRules :boolean = false;
  settingsKey :any = SettingsKey;
  onOffQuotaionsSetting :boolean = false;
  showSupplierPoSourceSkuSetting :boolean = false;
  showSupplierPoDescriptionSetting :boolean = false;
  alternateIds :any = [];
  defaultWarehouseGroupFromInventorySettings :IWarehouseGroup = null;
  showProductVariants :{ [key :string] :boolean } = {};

  productTypes = ProductTypes;

  loadingCustomFields = false;
  customFieldFormValuesJson: string;
  customFields: ICustomField[] = [];
  eCustomFieldObject = ECustomFieldObject;
  displayCustomFieldValues: any[] = [];

  constructor(
    private modalSvc :NgbModal,
    private fb :UntypedFormBuilder,
    private factorySvc :FactoryService,
    private toastr :ToastrService,
    private poService :PoService,
    private settingsSvc :SettingsService,
    private rfqSvc :RfqService,
    private authService :AuthService,
    private tagSvc :ProductTagService,
    private staffService :StaffService,
    private locationSvc :LocationService,
    private cd :ChangeDetectorRef,
    private datePipe :DatePipe,
    private clientSvc :ClientService,
    private clientPoSvc :ClientPurchaseOrderService,
    private feaureToggleService :FeatureToggleService,
    private unitConversionRuleService :UnitConversionRuleService,
    private router :Router,
    private activeRoute :ActivatedRoute,
    private dialog :MatDialog,
    private decimalPlacesPipe :DecimalPlacesPipe,
    private warehouseGroupService :LocationWarehouseGroupApiService,
    private snackBar :MatSnackBar,
    @Optional() public activeModal :NgbActiveModal,
    @Optional()
    public dialogRef :MatDialogRef<PurchaseOrderInlineFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData :any,
    private featureFlagPipe :FeatureFlagPipe, // @TODO use featureToggleService instead
    private errorHandlingUtilService :ErrorHandlingUtilService,
    private customFieldApiService :CustomFieldApiService,
  ) {
    if (this.dialogRef && dialogData && dialogData.isModal) {
      this.isModal = dialogData.isModal;
      this.stockGridItemIds = dialogData.stockGridItemIds;
    }
  }

  ngOnInit() :void {
    this.loadUomRules();

    this.getWarehouses();
    this.loadClient();
    this.loadInvoices();
    this.getOnOffQuotationSetting().subscribe();
    this.getSupplierPoDisplaySettings();
    this.loadDefaultWarehouseGroup();

    this.staffService.staff$.pipe(takeUntil(this.onDestroy$)).subscribe((staff) => {
      this.staff = staff.map<AtMentionItem>((user) => ({
        id: user.id,
        name: user.handle,
        type: 'user' as AtMentionItemType,
      }));
    });

    this.tagSvc.getTags({ parent_only: true }, null);
    this.tagSvc.formattedRecord$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((tags :any) => {
        this.tags = tags;
      });

    this.loadRfqs();
    this.rfq$.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this._kitRfqs.next(data);
    });

    this.formData = this.fb.group({
      factory_id: [null, Validators.required],
      location_id: [0],
      warehouse_id: [0],
      street_address_1: [''],
      street_address_2: [''],
      city: [''],
      state: [''],
      zip: [''],
      country: [''],
      default_ship_to_address: ['ship_to_address'],
      order_date: [null, Validators.required],
      tracking_info: [''],
      payment_terms: [null, Validators.required],
      requested_ship_date: [null, Validators.required],
      arrival_due_date: [null, Validators.required],
      invoice_date: [null],
      private_note: [''],
      public_note: [''],
      order_type: [1, Validators.required],
      logistic: ['exw', Validators.required],
      intl_shippping: ['sea'],
      po_items: this.fb.array([]),
      po_custom_items: this.fb.array([]),
      rfq_id: [null],
      tags: [[]],
      alternate_ids: [[]],
      customFieldValues: this.fb.array([]),
    });

    this.formData.addControl('clients', new UntypedFormControl([]));
    this.formData.addControl('invoices', new UntypedFormControl([]));
    this.formData.get('requested_ship_date').setValidators([]);
    this.formData.get('arrival_due_date').setValidators([]);
    this.formData
      .get('order_date')
      .patchValue(this.datePipe.transform(new Date(), 'yyyy-MM-dd'));

    this.settingsSvc.masterfile$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((settings :any) => {
        if (settings.LOGISTICS) {
          this.logistics = settings.LOGISTICS;
          if (settings.DEFAULTS) {
            const defaultLogistic = settings.DEFAULTS.find(
              (item) => item.key === 'default_logistics',
            );
            if (defaultLogistic) {
              this.formData.patchValue({
                logistic: defaultLogistic.value || 'exw',
              });
            }
          }
        }
      });

    this.settingsSvc.settings$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((settings :any) => {
        this.sysSettings = settings;
      });

    this.settingsSvc.paymentTerms$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((paymentTerms :any) => {
        if (paymentTerms && paymentTerms.length > 0) {
          this.paymentTerms = paymentTerms;
          if (this.purchaseOrder) {
          } else {
            this.formData
              .get('payment_terms')
              .patchValue(this.paymentTerms[0].label);
          }
        }
      });

    if (this.quotation) {
      this.addLineItemFromQuotation();
    }

    this.loadRfqs();
    this.updatePoItemsValidator();
    this.convertPoItemsUnitPrice();
    this.factory$ = this.factorySvc.factory$;
    this.loadCustomFields();

    // Handle custom field values from purchaseOrder input
    if (this.purchaseOrder?.custom_field_values) {
      const customFieldValuesArray = this.purchaseOrder.custom_field_values.map((value: any) => ({
        custom_field: value.custom_field,
        value: value.value_string ?? value.value_number ?? value.value_date ?? ''
      }));
      this.customFieldFormValuesJson = JSON.stringify(customFieldValuesArray);
    }

    this.updateDisplayCustomFieldValues();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  private processEachSKUItem() :void {
    const isInitItems :boolean = true;
    this.rfqSvc
      .searchSKUDropdown({
        rfqIds: this.stockGridItemIds,
        noKits: true,
        relations:
          'basePrice,tags.tag_details,variantParent,unitOfMeasures,quotations',
        per_page: 9999,
        supplierId: this.formData.value.factory_id,
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (resp :any) => {
          resp.forEach((item) => {
            this.onMultiselectItems({ item: item }, isInitItems);
          });
        },
        (error) => {
          // Handle error
        },
      );
  }

  loadUomRules() {
    this.loadingUomRules = true;
    this.unitConversionRuleService
      .getAsync({
        limit: 1000,
        page: 1,
        sortDirection: 'desc',
        sortField: 'created_at',
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res :{ data :any[] }) => {
        this.loadingUomRules = false;
        this.uomRules = res.data;
        this.convertPoItemsUnitPrice();

        if (!this.isModal) {
          this.loadFromRouteParams().subscribe();
        } else {
          this.pageTitle = 'New Purchase Order';
          this.isPageLoad = false;
        }
      });
  }

  addLineItemFromQuotation() :void {
    const poItems :UntypedFormArray = this.formData.get(
      'po_items',
    ) as UntypedFormArray;
    const rfq :string[] = this.rfq;
    const fbGroup :UntypedFormBuilder = this.fb;
    const quotation :string[] = this.quotation;
    this.quotation.tiered_pricing_json.forEach((item, idx) => {
      this.logistic_1_payment_term = item['logistic_1_payment_term'];
      const unitPrice = item['logistic_1']
        ? item['logistic_1']
        : rfq['base_price'] && rfq['base_price'].computed_weighted
          ? rfq['base_price'].computed_weighted
          : 0;

      poItems.push(
        fbGroup.group({
          rfq: {
            ...rfq,
            id: rfq['id'],
            sku: rfq['internal_sku'],
            product_name: rfq['product_name'],
          },
          quantity: item['quantity'],
          source_sku: quotation['source_sku'],
          description: '',
          unit_price: unitPrice,
          line_total: item['quantity'] * unitPrice,
          downpayment_percent: item['logistic_1_downpayment_percent'],
          downpayment_amount: 0,
          checked: false,
          total_first: 0,
          cbd: 0,
          ordered_uom_id: null,
          ordered_qty: 0,
          base_uom_id: null,
          isItemChangedOnPoUpdate: null,
        }),
      );
      this.updateLineItemUom(idx);
    });
    this.formData.get('payment_terms').patchValue(this.logistic_1_payment_term);
    this.computeTotal();
  }

  getWarehouses() {
    this.locationSvc
      .getAll({ all: 1, parent_id: 0 })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((resp) => {
        this.warehouses = resp;
      });
  }

  onSelectedSKUItem(idx :number, data :any) :void {
    if (!data) {
      return;
    }

    if (
      !this.feaureToggleService.featureEnabled(EFeatureFlag.SUPPLIER_SOURCE_SKU) &&
      this.onOffQuotaionsSetting
    ) {
      this.tryViewQuotations(idx);
    } else if (
      this.feaureToggleService.featureEnabled(EFeatureFlag.SUPPLIER_SOURCE_SKU)
    ) {
      const lineItemArray = this.poItemsFormArray.at(idx) as UntypedFormGroup;
      const unitPrice = Number(
        this.decimalPlacesPipe.transform(data?.base_price?.weighted ?? 0),
      );
      const itemQuantity = 1;
      lineItemArray.patchValue(
        {
          quantity: 1,
          source_sku: data?.supplier_sku || '',
          unit_price: unitPrice ?? 0,
          sample_price: unitPrice ?? 0,
          original_unit_price: unitPrice,
          converted_unit_price: null,
          line_total: unitPrice * itemQuantity,
        },
        { emitEvent: false },
      );
    } else {
      this.getUnitPriceBasedFromCostCalculationSetting(idx, data.base_price);
    }
    this.itemChangeOnPoUpdate(idx);
    this.updateLineItemUom(idx);
    this.computeTotal(idx);
  }

  private itemChangeOnPoUpdate(idx) :void {
    const items :UntypedFormArray = this.formData.get(
      'po_items',
    ) as UntypedFormArray;
    const item = this.formData.value.po_items[idx];
    if (this.purchaseOrder) {
      item.isItemChangedOnPoUpdate = true;
    } else {
      item.isItemChangedOnPoUpdate = false;
    }
    items.at(idx).patchValue(item);
  }

  private updateLineItemUom(idx :number) :void {
    const poItems :UntypedFormArray = this.formData.get(
      'po_items',
    ) as UntypedFormArray;
    const item = this.formData.value.po_items[idx];

    if (item.rfq?.unit_of_measures) {
      const uomValues = this.getOrderedUOMValues(item);
      poItems.at(idx).patchValue(uomValues);
    }
  }

  focusItem(idx :number) :void {
    const itemRowId = 'itemRowId' + (idx + 1);
    const input = document.querySelector(
      'ng-select[id=' +
        itemRowId +
        '] .ng-select-container .ng-value-container .ng-input input ',
    ) as HTMLElement;
    if (input) {
      setTimeout(() => {
        input.focus();
      }, 10);
    } else {
      setTimeout(() => {
        this.focusItem(idx);
      }, 10);

      return;
    }
  }

  showTooltip(item) {
    return item?.value?.rfq?.product_name || item?.value?.product_name;
  }

  tryViewQuotations(idx, isInitItems :boolean = false) {
    const poItems :UntypedFormArray = this.formData.get(
      'po_items',
    ) as UntypedFormArray;
    const poItem :any = this.formData.value.po_items[idx];
    const quotationExists =
      poItem &&
      poItem.rfq &&
      poItem.rfq.quotations &&
      poItem.rfq.quotations.length > 0;
    if (quotationExists && !isInitItems) {
      const modalRef = this.modalSvc.open(AddOrderItemsFormComponent, {
        size: 'lg',
        windowClass: 'po-form-modal',
      });
      modalRef.componentInstance.formValue = this.formData.value;
      modalRef.componentInstance.rfq = poItem.rfq;
      modalRef.result.then(
        (rowItem :any) => {
          poItems.at(idx).patchValue({
            cbd: rowItem.cbd,
            line_total: rowItem.line_total,
            downpayment_percent: rowItem.downpayment_percent,
            unit_price: rowItem.unit_price,
            source_sku: rowItem.source_sku,
            description: rowItem?.description,
            total_first: rowItem.total_first,
            quantity: rowItem.quantity,
            sample_price: rowItem.unit_price,
          });

          this.computeTotal(idx, quotationExists);
          this.focusItem(idx);
        },
        () => {
          const basePrice = this.getUnitPriceFromRfqBasePrice(
            poItem.rfq['base_price'],
          );
          poItems.at(idx).patchValue({
            unit_price: basePrice,
            sample_price: basePrice,
          });

          this.computeTotal(idx);
        },
      );
    } else {
      const basePrice = this.getUnitPriceFromRfqBasePrice(poItem.rfq['base_price']);
      poItems.at(idx).patchValue({
        unit_price: basePrice,
        sample_price: basePrice,
      });

      this.computeTotal(idx);
      this.focusItem(idx);
    }
  }

  getUnitPriceFromRfqBasePrice(basePrice :any = null) :number {
    if (!basePrice || !basePrice.computed_weighted) {
      return 0;
    }

    return basePrice.computed_weighted;
  }

  private getUnitPriceBasedFromCostCalculationSetting(
    idx :number,
    basePrice :any,
  ) :void {
    if (isNumber(basePrice)) {
      basePrice = {
        computed_weighted: basePrice,
        computed_fifo: basePrice,
        computed_lastpo: basePrice,
      };
    }
    const items :UntypedFormArray = this.poItemsFormArray;
    const costCalculationMethod =
      this.sysSettings?.purchase_order_settings?.cost_calculation_method;

    let unitPrice :number = 0;
    let samplePrice :number = 0;
    switch (costCalculationMethod) {
      case CostCalculationMethodSetting.FIFO:
        samplePrice = unitPrice = basePrice?.computed_fifo;
        break;

      case CostCalculationMethodSetting.LASTPO:
        samplePrice = unitPrice = basePrice?.computed_lastpo;
        break;

      default:
        samplePrice = unitPrice = basePrice?.computed_weighted;
        break;
    }

    items.at(idx).patchValue({
      unit_price: unitPrice ?? 0,
      sample_price: samplePrice ?? 0,
    });
  }

  removeItemRow(idx) {
    const poItems :UntypedFormArray = this.formData.get(
      'po_items',
    ) as UntypedFormArray;
    poItems.removeAt(idx);
    this.computeTotal();
    // this.poItems.splice(idx, 1);
  }

  addRowItem(item ?:any) {
    const poItems :UntypedFormArray = this.formData.get(
      'po_items',
    ) as UntypedFormArray;

    if (item) {
      const conversionRule = this.unitConversionRuleService.getConversionRule(
        this.uomRules,
        item,
        item.ordered_uom_id,
      );

      poItems.push(
        this.fb.group({
          ...item,
          checked: false,
          isItemChangedOnPoUpdate: null,
          sample_price: item.unit_price,
          converted_unit_price: item.unit_price,
          original_unit_price: conversionRule
            ? item.unit_price / conversionRule.conversionFactor
            : item.unit_price,
        }),
      );

      const idx = poItems.length - 1;
      this.updateLineItemUom(idx);
    } else {
      poItems.push(
        this.fb.group({
          rfq: {},
          quantity: 0,
          source_sku: '',
          description: '',
          unit_price: 0,
          line_total: 0,
          downpayment_percent: 0,
          downpayment_amount: 0,
          total_first: 0,
          cbd: 0,
          checked: false,
          ordered_uom_id: null,
          ordered_qty: 0,
          base_uom_id: null,
          isItemChangedOnPoUpdate: null,
          sample_price: 0,
          converted_unit_price: null,
          original_unit_price: 0,
        }),
      );
    }
  }

  removeCustomItemRow(idx) {
    const poItems :UntypedFormArray = this.formData.get(
      'po_custom_items',
    ) as UntypedFormArray;
    poItems.removeAt(idx);
    this.computeCustomItemTotal();
    // this.poItems.splice(idx, 1);
  }

  addRowCustomItem(item ?:any) {
    const poItems :UntypedFormArray = this.formData.get(
      'po_custom_items',
    ) as UntypedFormArray;
    if (item) {
      poItems.push(this.fb.group({ ...item, checked: false }));
    } else {
      poItems.push(
        this.fb.group({
          product_name: '',
          quantity: 0,
          unit_price: 0,
          line_total: 0,
          downpayment_percent: 0,
          downpayment_amount: 0,
          checked: false,
        }),
      );
    }
  }

  onLineItemChange(idx :number) :void {
    const poItem = this.formData.value.po_items[idx];
    if (poItem.quantity > 0) {
      poItem.unit_price = poItem.line_total / poItem.quantity;
    }
    this.computeTotal(idx);
  }

  computeTotal(
    idx ?:number,
    quotationExists :boolean = true,
    convert :boolean = true,
  ) {
    if (idx || idx >= 0) {
      const poItems :UntypedFormArray = this.formData.get(
        'po_items',
      ) as UntypedFormArray;
      const poItem :any = this.formData.value.po_items[idx];
      poItem.downpayment_percent =
        (poItem.downpayment_amount / poItem.line_total) * 100;
      let cbd :number = 0;
      const { unit_price, original_unit_price, converted_unit_price } = poItem;
      let unitPrice = original_unit_price || unit_price;
      const isOverrideUnitPrice =
        converted_unit_price && converted_unit_price !== unit_price;

      if (!converted_unit_price) {
        unitPrice = original_unit_price;
      } else if (isOverrideUnitPrice) {
        unitPrice = unit_price;
      }

      if (poItem.rfq && poItem.rfq.id) {
        cbd = poItem.rfq.box_width * poItem.rfq.box_height * poItem.rfq.box_length;
        if (cbd == 0) {
          cbd =
            poItem.rfq.carton_width *
            poItem.rfq.carton_height *
            poItem.rfq.carton_length;
        }

        poItem.unit_price = quotationExists
          ? unitPrice
          : poItem.rfq.base_price && poItem.rfq.base_price.computed_weighted
            ? poItem.rfq.base_price.computed_weighted
            : 0;
      }

      if (this.featureFlagPipe.transform(EFeatureFlag.SUPPLIER_SOURCE_SKU)) {
        poItem.sample_price = poItem.unit_price;
      }
      if (convert && poItem.sample_price && !isOverrideUnitPrice) {
        poItem.converted_unit_price = this.getConvertedUnitPrice(
          { ...poItem, item: poItem.rfq },
          poItem.sample_price,
        );
      }

      let updatedUnitPrice :number;
      if (isOverrideUnitPrice) {
        updatedUnitPrice = poItem.unit_price;
      } else if (poItem.converted_unit_price) {
        updatedUnitPrice = poItem.converted_unit_price;
      } else if (poItem.unit_price) {
        updatedUnitPrice = poItem.unit_price;
      } else {
        updatedUnitPrice = unit_price;
      }

      poItem.line_total = DecimalPlacesUtils.format(
        poItem.quantity * updatedUnitPrice - poItem.downpayment_amount,
      );

      let newLineItemValues :any = {
        ordered_qty: poItem.quantity,
      };
      if (poItem.rfq?.unit_of_measures) {
        newLineItemValues = this.getOrderedUOMValues(poItem);
      }

      poItems.at(idx).patchValue({
        ...newLineItemValues,
        cbd: cbd,
        line_total: poItem.line_total,
        downpayment_percent: poItem.downpayment_percent,
        unit_price: isOverrideUnitPrice
          ? unit_price
          : poItem.converted_unit_price || unit_price,
        original_unit_price: poItem.original_unit_price,
        converted_unit_price: poItem.converted_unit_price || poItem.unit_price,
      });
    }
    this.total = { quantity: 0, amount: 0 };
    this.formData.value.po_items.forEach((row) => {
      if (row.rfq?.id) {
        this.total.quantity += +this.decimalPlacesPipe.transform(row.quantity);
        this.total.amount += +this.decimalPlacesPipe.transform(row.line_total);
      }
    });
  }

  // for custom line items or items under additional fees
  computeCustomItemTotal(idx ?:number) {
    if (idx || idx >= 0) {
      const poItems :UntypedFormArray = this.formData.get(
        'po_custom_items',
      ) as UntypedFormArray;
      const poItem :any = this.formData.value.po_custom_items[idx];
      poItem.line_total = poItem.quantity * poItem.unit_price;
      poItem.downpayment_percent =
        (poItem.downpayment_amount / poItem.line_total) * 100;
      const cbd :number = 0;
      poItems.at(idx).patchValue({
        cbd: cbd,
        line_total: poItem.line_total,
        downpayment_percent: poItem.downpayment_percent,
      });
    }
    this.custom_item_total = { quantity: 0, amount: 0 };
    this.formData.value.po_custom_items.forEach((row) => {
      this.custom_item_total.quantity += row.quantity;
      this.custom_item_total.amount += row.line_total;
    });
  }

  confirmOrder() {
    const fd = Object.assign({}, this.formData.getRawValue());

    fd.logistic_code = fd.logistic;
    fd.logistic_label = this.logistics[fd.logistic];
    fd.order_quantity = this.total.quantity;
    fd.order_cost = this.total.amount + this.custom_item_total.amount;
    fd.total_cost = this.total.amount + this.custom_item_total.amount;
    fd.item_count = 0;
    fd.downpayment = 0;

    fd.order_status_id = 1;
    fd.order_status_text = 'active';
    fd.order_status_date = new Date();

    if (!this.showIntlShipping) {
      delete fd.intl_shippping;
    }

    fd.landed_intl = 0;
    // computer for estimated landed cost
    const POSettings :any = this.sysSettings.purchase_order_settings;
    let totalIntl :number = 0;
    let totalDomestic :number = 0;
    const confirmedItems :any[] = [];

    let order = 0;
    fd.po_items
      .filter((row) => row.rfq && row.rfq.id)
      .forEach((item :any) => {
        item.rfq_id = item.rfq.id;
        item.internal_sku = item.rfq.sku;
        item.product_name = item.rfq.product_name;
        // item.product_description = item.rfq.product_description;
        fd.downpayment = fd.downpayment + item.downpayment_amount;
        delete item.rfq;
        delete item.checked;

        if (POSettings?.domestic_costs) {
          const cbmKey :string = fd.logistic_code + '_cbm';
          if (
            item.cbd &&
            item.cbd > 0 &&
            POSettings.domestic_costs[cbmKey] &&
            POSettings.domestic_costs[cbmKey] > 0
          ) {
            totalDomestic += POSettings.domestic_costs[cbmKey] * item.cbd * 0.0254;
          } else {
            totalDomestic +=
              (item.line_total * POSettings.domestic_costs[fd.logistic_code]) / 100;
          }
        }
        if (this.showIntlShipping && POSettings.international_costs) {
          const cbmKey :string = fd.intl_shippping + '_cbm';
          if (
            item.cbd &&
            item.cbd > 0 &&
            POSettings.international_costs[cbmKey] &&
            POSettings.international_costs[cbmKey] > 0
          ) {
            totalIntl += POSettings.international_costs[cbmKey] * item.cbd * 0.0254;
          } else {
            totalIntl +=
              (item.line_total *
                POSettings.international_costs[fd.intl_shippping]) /
              100;
          }
        }
        if (!item.downpayment_amount) {
          item.downpayment_amount = 0;
          item.downpayment_percent = 0;
        } else if (!item.downpayment_percent) {
          item.downpayment_percent = 0;
        }

        item.order = order;
        if (item?.isItemChangedOnPoUpdate) {
          delete item.id;
          delete item.product_description;
        }
        delete item?.isItemChangedOnPoUpdate;

        confirmedItems.push(item);
        order += 1;
      });
    fd.items = confirmedItems;
    fd.item_count = confirmedItems.length;
    fd.landed_intl = totalIntl;
    fd.landed_domestic = totalDomestic ?? 0;
    fd.custom_items = fd.po_custom_items.filter((e) => e.product_name != '');

    order = 0;
    fd.custom_items.forEach((item) => {
      item.order = order;
      delete item.checked;
      order += 1;
    });

    const terms :any = this.paymentTerms.find(
      (row) => row.label == fd.payment_terms,
    );
    fd.due_amount = (parseFloat(terms.min_p) * fd.total_cost) / 100;
    if (fd.due_amount > 0) {
      fd.due_date = new Date();
    }

    fd.alternate_ids = this.alternateIds;

    // Add custom field values to the payload
    fd.customFieldValues = this.formattedCustomFieldValues;

    // remove logistics
    delete fd.logistic;
    delete fd.po_items;
    delete fd.po_custom_items;

    this.loading = true;
    if (this.purchaseOrder && this.purchaseOrder.id) {
      delete fd.rfq_id;
      this.poService
        .updateOrder(this.purchaseOrder.id, fd)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (resp :any) => {
            this.toastr.success('Updated purchase order.');
            this.router.navigateByUrl('orders');
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.errorHandlingUtilService.handleError(
              error,
              'Error updating purchase order. Please try again later or contact support.',
            );
            this.cd.detectChanges();
          },
        );
    } else {
      this.poService.createOrder(fd).subscribe(
        (resp :any) => {
          this.toastr.success('Created purchase order.');
          this.loading = false;

          if (!this.isModal) {
            this.router.navigateByUrl('orders');
          } else {
            this.cd.detectChanges();
            this.dialogRef.close(true);
          }
        },
        (error) => {
          this.loading = false;
          this.errorHandlingUtilService.handleError(
            error,
            'Error updating purchase order. Please try again later or contact support.',
          );
          this.cd.detectChanges();
        },
      );
    }
  }

  getFactoryRfqs() {
    if (!this.formData.value || !this.formData.value.factory_id) {
      return;
    }

    this.showIntlShipping = false;
    const factory :any = this.factorySvc.getById(this.formData.value.factory_id);

    if (factory) {
      this.formData.get('payment_terms').patchValue(factory?.default_payment_term);
    }

    if (
      this.sysSettings.account_country &&
      this.sysSettings.account_country.trim().toLowerCase() !=
        factory.country.trim().toLowerCase()
    ) {
      this.showIntlShipping = true;
    }

    if (
      !this.activeFactory ||
      this.activeFactory.id != this.formData.value.factory_id
    ) {
      this.activeFactory = this.factorySvc.getById(this.formData.value.factory_id);
    }
  }

  addRfqItems(rfq ?:any) {
    const modalRef = this.modalSvc.open(AddOrderItemsFormComponent, {
      size: 'lg',
      windowClass: 'po-form-modal',
    });
    modalRef.componentInstance.factoryItems = this.factoryItems;
    modalRef.componentInstance.formValue = this.formData.value;
    if (rfq) {
      modalRef.componentInstance.rfq = rfq;
    }
  }

  onTabChanged(e) {
    this.activeTab = e.index;

    if (this.isModal && this.activeTab && !this.hasProcessedSKUs) {
      this.processEachSKUItem();
      this.hasProcessedSKUs = true;
    }
  }

  trackByFn(item :any) {
    return item.id;
  }

  createNew(factory ?:any) {
    const modalRef = this.modalSvc.open(AuthFormModalComponent, {
      size: 'lg',
      windowClass: 'auth-form-modal',
    });
    if (factory) {
      modalRef.componentInstance.factory = factory;
    }
  }

  createRfqForClient() {
    const modalRef = this.modalSvc.open(CreateClientRfqComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
  }

  private loadRfqs() {
    this.rfq$ = concat(
      of([]), // default items
      this.rfqInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.rfqLoading = true)),
        switchMap((term) =>
          this.rfqSvc
            .searchSKU({ sku: term, factoryId: this.formData.value.factory_id })
            .pipe(
              catchError(() => of([])), // empty list on error
              tap(() => (this.rfqLoading = false)),
              map((resp :any) => resp),
            ),
        ),
      ),
    );
  }

  addVariantSku() {
    const modalRef = this.modalSvc.open(RfqVariantSkusPopupComponent, {
      windowClass: 'rfq-variant-sku-form',
    });
    modalRef.componentInstance.selectParent = true;
    modalRef.componentInstance.factoryId = this.formData.value.factory_id;
    modalRef.result.then((data :any) => {
      this.addRowItem({
        rfq: {
          ...data,
          sku: data.internal_sku,
        },
        quantity: 0,
        source_sku: '',
        description: '',
        unit_price: data.wholesale_price, // unit price
        line_total: 0,
        downpayment_percent: 0,
        downpayment_amount: 0,
        total_first: 0,
        cbd: 0,
        checked: false,
        ordered_uom_id: data.default_purchase_unit_id,
        ordered_qty: 1,
        base_uom_id: data.default_purchase_unit_id,
        sample_price: data.wholesale_price,
      });
    });
  }

  onAddMultipleLineItems() :void {
    this.getDefaultWarehouseGroupId().subscribe({
      next: (warehousGroupdId :string) => {
        if (!warehousGroupdId) {
          this.toastr.error(
            'No default warehouse group assigned in system settings.',
          );

          return;
        }
        this.openMultipleLineItemDialog(warehousGroupdId);
      },
    });
    //
  }

  downloadTemplate() {
    this.poService.downloadTemplate();
  }

  onFileUpload(event) {
    const file = event.target.files[0];
    const fileExt = file.name.split('.').pop();
    const fd = new FormData();
    fd.append('file', file, file.name);

    Swal.fire('', 'Uploading, please wait...');
    Swal.showLoading();

    if (!['csv'].includes(fileExt.toLowerCase())) {
      Swal.fire('Invalid file', 'Please upload a CSV file.', 'error');
      // this.cd.detectChanges();
      return;
    }

    Swal.fire('', 'Uploading, please wait...');
    this.poService
      .uploadPOLineItems(fd)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data :any) => {
        Swal.fire('Uploaded.', 'Uploaded successfully.');
        Swal.hideLoading();

        if (!data.length) return;

        const poItems :UntypedFormArray = this.formData.get(
          'po_items',
        ) as UntypedFormArray;
        data.forEach((item) => {
          poItems.push(
            this.fb.group({
              checked: false,
              rfq: { ...item.rfq, sku: item.rfq.internal_sku },
              quantity: item.quantity,
              source_sku: item.source_sku,
              description: item?.description,
              unit_price: item.unit_price || 0,
              original_unit_price: item.unit_price || 0,
              converted_unit_price: null,
              line_total: item.line_total,
              downpayment_percent: 0,
              downpayment_amount: item.downpayment || 0,
              ordered_uom_id: item?.rfq?.unit_of_measures?.default_purchase_unit_id,
              base_uom_id: item?.rfq?.unit_of_measures?.default_purchase_unit_id,
              total_first: 0,
              cbd: 0,
            }),
          );

          this.computeTotal(poItems.length - 1);
        });
      });
  }

  customTagsSearchFn(term :any, item :any) {
    term = term.toLocaleLowerCase();

    return item.name
      .toLowerCase()
      .replace(/&nbsp;/gi, '')
      .includes(term);
  }

  changeDefaultShipTo(default_ship_to_address :any) :void {
    this.formData.get('country').patchValue('');
    this.formData.get('zip').patchValue('');
    this.formData.get('state').patchValue('');
    this.formData.get('city').patchValue('');
    this.formData.get('street_address_2').patchValue('');
    this.formData.get('street_address_1').patchValue('');

    if (default_ship_to_address == 'ship_to_address') {
      this.formData.get('warehouse_id').patchValue(0);
      this.cd.detectChanges();
    }
  }

  changeWarehouse(warehouse_id :any) :void {
    const warehouse = this.warehouses.find((row) => row.id == warehouse_id);

    if (warehouse) {
      this.formData.get('country').patchValue(warehouse.country);
      this.formData.get('zip').patchValue(warehouse.zip);
      this.formData.get('state').patchValue(warehouse.state);
      this.formData.get('city').patchValue(warehouse.city);
      this.formData.get('street_address_2').patchValue(warehouse.street_address_2);
      this.formData.get('street_address_1').patchValue(warehouse.street_address_1);

      this.cd.detectChanges();
    }
  }

  onMultiselectItems(data :any, isInitItems :boolean = false) {
    const lineItems :UntypedFormArray = this.formData.get(
      'po_items',
    ) as UntypedFormArray;
    const { item } = data;
    let index = lineItems.value.filter((item) => item?.rfq?.id).length;

    if (this.isKitItem(item)) {
      this.handleKitItemDialog(item);

      return;
    }

    if (
      !this.feaureToggleService.featureEnabled(EFeatureFlag.SUPPLIER_SOURCE_SKU) &&
      this.onOffQuotaionsSetting
    ) {
      this.tryViewQuotations(index, isInitItems);
    } else if (
      this.feaureToggleService.featureEnabled(EFeatureFlag.SUPPLIER_SOURCE_SKU)
    ) {
      const selectedUomId = data.item.uom_id || item.default_purchase_unit_id || 0;
      const existingItemIndex = lineItems.value.findIndex(
        (lineItem) =>
          lineItem?.rfq?.id === data.item.id &&
          lineItem.ordered_uom_id === selectedUomId,
      );

      const uomValues :any = {
        ordered_uom_id: item.uom_id || item.default_purchase_unit_id,
        ordered_qty: item.quantity || 1,
        base_uom_id: item.default_purchase_unit_id,
      };

      const itemQuantity = item.quantity || 1;
      const unitPrice = Number(
        this.decimalPlacesPipe.transform(data.item?.base_price?.weighted ?? 0),
      );
      if (existingItemIndex >= 0) {
        this.updateExistingLineItem(existingItemIndex, item, lineItems);
        index = existingItemIndex;
      } else {
        lineItems.insert(
          index,
          this.fb.group({
            rfq: item,
            quantity: itemQuantity,
            source_sku: item.supplier_sku,
            description: '',
            unit_price: unitPrice,
            original_unit_price: unitPrice,
            converted_unit_price: null,
            line_total: itemQuantity * unitPrice,
            downpayment_percent: 0,
            downpayment_amount: 0,
            total_first: 0,
            cbd: 0,
            checked: false,
            base_uom_id: [uomValues.base_uom_id],
            ordered_uom_id: [uomValues.ordered_uom_id],
            ordered_qty: [uomValues.ordered_qty],
            sample_price: 0,
            is_product_variant: item.variant_parent ? true : false,
            product_variants: item?.product_variants
              ? this.fb.array(
                  JSON.parse(item.product_variants).map((variant) => {
                    return this.fb.group({
                      name: variant.variant_name,
                      variant_terms: variant.variant_terms
                        ? this.fb.array(variant.variant_terms.map((term) => term))
                        : this.fb.array([]),
                    });
                  }),
                )
              : this.fb.array([]),
          }),
        );
      }
    } else {
      this.getUnitPriceBasedFromCostCalculationSetting(index, item.base_price);
    }
    this.updateLineItemUom(index);
    this.computeTotal(index);
  }

  onCustomFieldValuesChange(values: any): void {
    let arr: any[] = [];

    if (typeof values === 'string') {
      try {
        arr = JSON.parse(values);
      } catch {
        arr = [];
      }
    } else if (Array.isArray(values)) {
      arr = values;
    } else if (values && typeof values === 'object') {
      arr = [values];
    }

    const formArray = this.formData.get('customFieldValues') as FormArray;
    formArray.clear();
    arr.forEach(val => {
      formArray.push(this.fb.group({
        custom_field_id: [val.custom_field],
        value_string: [val.value],
        value_number: [val.value],
        value_date: [val.value],
        custom_field: [val.custom_field]
      }));
    });
    this.updateDisplayCustomFieldValues();
  }

  updateCheckedItems(isCustomItem ?:boolean) :void {
    if (isCustomItem) {
      const lineItems :UntypedFormArray = this.formData.get(
        'po_custom_items',
      ) as UntypedFormArray;
      this.formData.value.po_custom_items.forEach((item, idx) => {
        lineItems.at(idx).patchValue({ checked: this.checkedAll.po_custom_items });
      });
    } else {
      const lineItems :UntypedFormArray = this.formData.get(
        'po_items',
      ) as UntypedFormArray;
      this.formData.value.po_items.forEach((item, idx) => {
        lineItems.at(idx).patchValue({ checked: this.checkedAll.po_items });
      });
    }
  }

  canBulkUpdate(isCustomItem ?:boolean) :boolean {
    if (isCustomItem) {
      return this.formData.value.po_custom_items.filter((e) => e.checked).length;
    }

    return this.formData.value.po_items.filter((e) => e.checked).length;
  }

  async bulkUpdate(
    field :PurchaseOrderLineItemFormField,
    isCustomItem ?:boolean,
  ) :Promise<void> {
    const label = {
      quantity: 'Quantity',
      unit_price: 'Price',
      downpayment_amount: 'Downpayment Amount',
    };

    const validationMessage = `Invalid ${label[field]}`;

    const result = await Swal.fire({
      text: `Update ${label[field]}`,
      showCancelButton: true,
      input: 'number',
      validationMessage: `Invalid ${label[field]}`,
      inputValidator: (value) => {
        // check if has non letters
        if (!/[^a-zA-Z]/.test(value)) {
          return validationMessage;
        }

        if (field === 'quantity' && !Number.isInteger(parseFloat(value))) {
          return validationMessage;
        }

        return null;
      },
    });

    if (result.value) {
      const value = result.value;

      if (isCustomItem) {
        const lineItems :UntypedFormArray = this.formData.get(
          'po_custom_items',
        ) as UntypedFormArray;
        this.formData.value.po_custom_items.forEach((item, idx) => {
          if (item.checked) {
            lineItems
              .at(idx)
              .patchValue({ [field]: parseFloat(value), checked: false });

            this.computeCustomItemTotal(idx);
          }
        });
        this.checkedAll.po_custom_items = false;
      } else {
        const lineItems :UntypedFormArray = this.formData.get(
          'po_items',
        ) as UntypedFormArray;
        this.formData.value.po_items.forEach((item, idx) => {
          if (item.checked) {
            lineItems
              .at(idx)
              .patchValue({ [field]: parseFloat(value), checked: false });

            this.computeTotal(idx, true, false);
          }
        });
        this.checkedAll.po_items = false;
      }
    }
  }

  addMultipleLineItemRows(rows :number = 1, isCustomItem ?:boolean) :void {
    [...Array(rows)].forEach(() => {
      if (isCustomItem) {
        this.addRowCustomItem();
      } else {
        this.addRowItem();
      }
    });

    this.checkedAll[isCustomItem ? 'po_custom_items' : 'po_items'] = false;
  }

  drop(event :CdkDragDrop<string[]>, isCustomItem ?:boolean) :void {
    const formArrayName = isCustomItem ? 'po_custom_items' : 'po_items';
    const lineItems :UntypedFormArray = this.formData.get(
      formArrayName,
    ) as UntypedFormArray;
    DraggableLineItemHelperService.moveItemInFormArray(
      lineItems,
      event.previousIndex,
      event.currentIndex,
    );
  }

  private getOrderedUOMValues(lineItem :any) {
    if (lineItem.rfq.default_purchase_unit_id <= 0 && lineItem.rfq.variant_parent) {
      lineItem.rfq.unit_of_measures = lineItem.rfq.variant_parent.unit_of_measures;
      lineItem.rfq.default_purchase_unit_id =
        lineItem.rfq.variant_parent.default_purchase_unit_id;
      lineItem.rfq.unit_class_id = lineItem.rfq.variant_parent.unit_class_id;
    }
    this.unitOfMeasures[lineItem.rfq.id] = lineItem.rfq.unit_of_measures;

    const uomValues = {
      ordered_uom_id: lineItem.ordered_uom_id
        ? lineItem.ordered_uom_id
        : lineItem.rfq.default_purchase_unit_id,
      ordered_qty: lineItem.quantity,
      base_uom_id: lineItem.base_uom_id
        ? lineItem.base_uom_id
        : lineItem.rfq.default_purchase_unit_id,
    };

    const baseUom :any = lineItem.rfq?.unit_of_measures?.find(
      (uomRow :any) => uomRow.base_unit == 1,
    );
    if (baseUom) {
      uomValues.base_uom_id = baseUom.id;
    }

    const uom :any = lineItem.rfq?.unit_of_measures?.find(
      (uomRow :any) => uomRow.id == lineItem.ordered_uom_id,
    );
    if (!uom) {
      return uomValues;
    }

    const conversionRule = this.unitConversionRuleService.getConversionRule(
      this.uomRules,
      lineItem,
      lineItem.ordered_uom_id,
    );

    if (!conversionRule) {
      uomValues.ordered_qty = lineItem.quantity;

      return uomValues;
    }
    uomValues.ordered_qty = this.decimalPlacesPipe.transform(
      +conversionRule.conversionFactor * lineItem.quantity,
    );

    return uomValues;
  }

  getUnitMeasure(idx :number) :string {
    const lineItem = this.formData.value.po_items[idx];
    const umId = lineItem.ordered_uom_id;
    const uom = lineItem.rfq?.unit_of_measures || [];
    const umIndex = uom.findIndex((um) => um.id === umId);

    if (umIndex !== -1 && umIndex !== undefined) {
      return uom[umIndex].name;
    }

    return null;
  }

  onClientSelect() :void {
    this.formData.patchValue({
      clients: this.selectedClients.map((e) => e.id),
    });
  }

  onInvoiceSelect() :void {
    this.formData.patchValue({
      invoices: this.selectedInvoices.map((e) => e.id),
    });
  }

  private loadClient() :void {
    const includeRelations :boolean = true;
    this.client$ = concat(
      this.clientSvc.search('', includeRelations), // default items
      this.clientInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.clientLoading = true)),
        debounceTime(lumConfig.debounce.search),
        switchMap((term) =>
          this.clientSvc.search(term, includeRelations).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.clientLoading = false)),
          ),
        ),
      ),
    );
  }

  private loadInvoices() :void {
    this.invoices$ = concat(
      of([]),
      this.invoiceInput$.pipe(
        distinctUntilChanged(),
        debounceTime(lumConfig.debounce.search),
        switchMap((term) =>
          this.clientPoSvc.search({ id: term }).pipe(catchError(() => of([]))),
        ),
      ),
    );
  }

  private getDefaultWarehouseGroupId() :Observable<any> {
    return this.settingsSvc
      .getKeyValue(this.settingsKey.DEFAULT_WAREHOUSE_GROUP_ID)
      .pipe(takeUntil(this.onDestroy$));
  }

  private openMultipleLineItemDialog(warehousGroupdId :string) :void {
    this.dialog
      .open(RfqLineItemsFormComponent, {
        data: {
          warehouse_group_id: warehousGroupdId,
          supplierId: this.formData.value.factory_id,
          warehouseId: this.warehouseId,
        },
        width: DialogConfig.sizes['xxx-large'],
        height: 'calc(100vh - 150px)',
        disableClose: true,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((lineItems) => {
        if (lineItems) {
          lineItems.forEach((item :IPurchaseOrderMultiselectLineItem) => {
            this.onMultiselectItems({ item });
          });

          this.cd.detectChanges();
        }
      });
  }

  // TODO: CREATE PIPE
  getKey(key :number, rowKey :number, elementId :string) :number {
    let inputs = 0;
    const parentEl = document.getElementById(elementId);
    if (parentEl) {
      inputs = parentEl.getElementsByTagName('input').length;
    }

    return key + rowKey * inputs;
  }

  get poItemsFormArray() :UntypedFormArray {
    return this.formData.get('po_items') as UntypedFormArray;
  }

  get isAuthAndTotalPaid() :boolean {
    return (
      this.authService.loginUser.prwx ===
        UserPermissionCodeConstant.ReadWriteExecute &&
      this.purchaseOrder &&
      this.purchaseOrder.total_paid === this.purchaseOrder.total_cost
    );
  }

  private updatePoItemsValidator() :void {
    this.formData
      .get('po_items')
      .valueChanges.pipe(takeUntil(this.onDestroy$))
      .subscribe((items) => {
        items.forEach((item, idx) => {
          if (item.rfq?.id) {
            const itemControl = (
              this.formData.controls.po_items as UntypedFormArray
            ).at(idx);
            itemControl.get('ordered_uom_id').setValidators(Validators.required);
          }
        });
      });
  }

  private getConvertedUnitPrice(lineItem :any, unitPrice :number) :number {
    const defaultPurchaseUnitId = lineItem.ordered_uom_id;
    if (!defaultPurchaseUnitId) return unitPrice;

    const conversionRule = this.unitConversionRuleService.getConversionRule(
      this.uomRules,
      lineItem,
      defaultPurchaseUnitId,
    );

    return conversionRule
      ? +conversionRule.conversionFactor * unitPrice
      : unitPrice;
  }

  onUnitPriceChange(idx :number) :void {
    const isExistingQuotation = true;
    const convertUnitPrice = false;

    this.computeTotal(idx, isExistingQuotation, convertUnitPrice);
  }

  private convertPoItemsUnitPrice() :void {
    if (!this.purchaseOrder) return;

    const lineItems :UntypedFormArray = this.formData.get(
      'po_items',
    ) as UntypedFormArray;
    this.formData.value.po_items.forEach((item, idx) => {
      const samplePrice = this.getSamplePrice(item, item.unit_price);
      lineItems.at(idx).patchValue({
        sample_price: samplePrice,
      });
    });
  }

  private getSamplePrice(lineItem :any, unitPrice :number) :number {
    const orderedUomId = lineItem.ordered_uom_id;

    if (!orderedUomId) return unitPrice;

    const conversionRule = this.unitConversionRuleService.getConversionRule(
      this.uomRules,
      lineItem,
      orderedUomId,
    );

    return conversionRule ? unitPrice / conversionRule.conversionFactor : unitPrice;
  }

  private getOnOffQuotationSetting() :Observable<any> {
    return this.settingsSvc.getKeyValue(this.settingsKey.ON_OFF_QUOTATIONS).pipe(
      tap((setValue) => {
        if (setValue) {
          this.onOffQuotaionsSetting = setValue === true ? true : false;
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getSupplierPoDisplaySettings() :void {
    this.subscribeToSetting(
      this.settingsKey.SHOW_SUPPLIER_PO_SOURCE_SKU,
      (value :boolean) => {
        this.showSupplierPoSourceSkuSetting = value;
        this.cd.detectChanges();
      },
    );

    this.subscribeToSetting(
      this.settingsKey.SHOW_SUPPLIER_PO_DESCRIPTION,
      (value :boolean) => {
        this.showSupplierPoDescriptionSetting = value;
        this.cd.detectChanges();
      },
    );
  }

  private subscribeToSetting(key :string, onNext :(value :boolean) => void) :void {
    this.settingsSvc
      .getCachedKeyValueSettings(key)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(onNext);
  }

  private loadFromRouteParams() :Observable<Params> {
    return this.activeRoute.params.pipe(
      tap((response :any) => {
        if (response) {
          this.getAndLoadActivePurchaseOrder(Number(response.id)).subscribe();
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getAndLoadActivePurchaseOrder(poId :number) :Observable<any> {
    this.isPageLoad = true;

    return this.poService.getPurchaseOrderByIdAsync(poId).pipe(
      tap((response :any) => {
        if (response && response.id) {
          this.purchaseOrder = response;
          this.populatePurchaseOrder();
          this.isPageLoad = false;
        } else {
          this.pageTitle = 'New Purchase Order';
          this.isPageLoad = false;
        }
        this.cd.detectChanges();
      }),
      catchError((response) => {
        this.loading = false;
        this.cd.detectChanges();

        return throwError(response.error);
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private populatePurchaseOrder() :void {
    if (Object.keys(this.purchaseOrder).length !== 0) {
      this.formData.patchValue(this.purchaseOrder);
      this.formData.patchValue({
        tags: this.purchaseOrder.tags.map((e) => e.id),
      });

      this.selectedClients = this.purchaseOrder.clients;
      this.formData.patchValue({
        clients: this.purchaseOrder.clients.map((e) => e.id),
      });

      this.selectedInvoices = this.purchaseOrder.invoices;
      this.formData.patchValue({
        invoices: this.purchaseOrder.invoices.map((e) => e.id),
      });

      // Handle both alternate_ids and model_alternate_ids
      const allAlternateIds = [
        ...(this.purchaseOrder.alternate_ids || []),
        ...(this.purchaseOrder.model_alternate_ids || []).map(modelAlternateId => ({
          id: modelAlternateId.id,
          purchase_order_id: modelAlternateId.model_id,
          alternate_id: modelAlternateId.alternate_id,
          created_at: modelAlternateId.created_at,
          updated_at: modelAlternateId.updated_at,
          deleted_at: null
        }))
      ];

      this.formData.patchValue({
        alternate_ids: allAlternateIds.map(alternateId => alternateId),
      });

      if (allAlternateIds.length > 0) {
        this.alternateIds = allAlternateIds.map(alternateId => alternateId.alternate_id);
      }

      this.formData.get('logistic').patchValue(this.purchaseOrder.logistic_code);
      this.pageTitle = 'Update Purchase Order';

      this.reset();
      this.purchaseOrder.purchase_order_items.forEach((item) => {
        item.rfq = {
          id: item?.rfq_id,
          sku: item?.internal_sku,
          product_name: item?.product_name,
          unit_class_id: item?.rfq?.unit_class_id,
          unit_of_measures: item?.rfq?.unit_of_measures,
          default_selling_unit_id: item?.rfq?.default_selling_unit_id,
          default_purchase_unit_id: item?.rfq?.default_purchase_unit_id,
        };

        this.addRowItem(item);
      });

      this.purchaseOrder.purchase_order_custom_items.forEach((item) => {
        this.addRowCustomItem(item);
      });
      this.activeFactory = this.purchaseOrder.factory;
      this.computeTotal();
      this.computeCustomItemTotal();
    } else if (this.quotation) {
      this.formData.get('factory_id').patchValue(this.quotation.factory_id);
      this.formData.get('logistic').patchValue(this.quotation.logistic_1);
      if (this.quotation.factory) {
        this.activeFactory = this.quotation.factory;
      }
    }
  }

  private isKitItem(item :IPurchaseOrderMultiselectLineItem) :boolean {
    return item.type === this.productTypes.KIT;
  }

  private handleKitItemDialog(item :IPurchaseOrderMultiselectLineItem) :void {
    const dialogRef = this.dialog.open(RfqKitItemsAddFormComponent, {
      width: DialogConfig.sizes['extra-large'],
      data: { kit: item },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.length > 0) {
        result.forEach((kitItem) => {
          this.onMultiselectItems({ item: kitItem });
        });
      }
    });
  }

  private updateExistingLineItem(
    index :number,
    item :IPurchaseOrderMultiselectLineItem,
    lineItems :UntypedFormArray,
  ) :void {
    const lineItem = lineItems.at(index).value;
    const lineItemQuantity = parseFloat(lineItem.quantity) || 0;
    lineItems.at(index).patchValue({
      quantity: this.decimalPlacesPipe.transform(
        lineItemQuantity + (item.quantity || 0),
      ),
    });
  }

  private loadDefaultWarehouseGroup() :void {
    this.warehouseGroupService
      .getDefaultWarehouseGroup({ relations: ['defaultWarehouse'] })
      .subscribe({
        next: (response :IWarehouseGroup) => {
          this.defaultWarehouseGroupFromInventorySettings = response;
        },
        error: (error) => {
          this.snackBar.open('Default warehouse group not set.', 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
      });
  }

  reset() :void {
    this.poService.reset();
  }

  private loadCustomFields(): void {
    this.loadingCustomFields = true;
    this.customFieldApiService
      .getAll({
        customFieldObject: this.eCustomFieldObject.SUPPLIER_PURCHASE_ORDER
      })
      .pipe(
        finalize(() => this.loadingCustomFields = false)
      )
      .subscribe({
        next: (customFields) => {
          this.customFields = customFields;
        },
        error: (error) => {
          this.loadingCustomFields = false
          this.snackBar.open('Error loading custom fields.', 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        }
      });
  }

  private updateDisplayCustomFieldValues(): void {
    let values: any[] = [];
    try {
      if (this.formData?.controls?.customFieldValues?.value?.length) {
        values = this.formData.controls.customFieldValues.value;
      } else if (this.customFieldFormValuesJson) {
        values = JSON.parse(this.customFieldFormValuesJson);
      }
    } catch {
      values = [];
    }

    this.displayCustomFieldValues = values
      .map(val => {
        const customField = this.customFields.find(
          f => f.id === (val.custom_field?.id || val.custom_field || val.custom_field_id)
        );
        if (!customField) return null;

        const value = this.resolveCustomFieldValue(val);

        return {
          id: val.id || null,
          custom_field: {
            id: customField.id,
            label: customField.label,
            type: customField.type,
          },
          value_string: (customField.type === 'string' || customField.type === 'dropdown') ? value : undefined,
          value_number: customField.type === 'number' ? value : undefined,
          value_date: customField.type === 'date' ? value : undefined,
        };
      })
      .filter(Boolean);
  }

  private resolveCustomFieldValue(val: any): any {
    if (val.value !== undefined) return val.value;
    if (val.value_string !== undefined) return val.value_string;
    if (val.value_number !== undefined) return val.value_number;
    if (val.value_date !== undefined) return val.value_date;
    return '';
  }

  get isUpdate() :boolean {
    return this.purchaseOrder
      ? Object.keys(this.purchaseOrder).length !== 0
      : false;
  }

  get authLoginUserPrwx() :number {
    return this.authService.loginUser.prwx;
  }

  get warehouseId() :number {
    return (
      this.formData.value.warehouse_id ||
      this.defaultWarehouseGroupFromInventorySettings?.defaultWarehouse?.id
    );
  }

  get formattedCustomFieldValues(): any[] {
    const formValue = this.formData.value;
    return formValue.customFieldValues.map((field: any) => {
      // Determine the correct value based on the field type
      let value = '';
      if (field.value_string !== null && field.value_string !== undefined) {
        value = field.value_string;
      } else if (field.value_number !== null && field.value_number !== undefined) {
        value = field.value_number;
      } else if (field.value_date !== null && field.value_date !== undefined) {
        value = field.value_date;
      }
      return {
        custom_field: field.custom_field_id,
        value: value
      };
    });
  }
}
